import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b01b2f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lpager" }
const _hoisted_2 = { key: 1 }

import HcIcon from '@/modern/components/ui/HcIcon.vue';

interface IPagerLink {
  label: string
  title: string
  to: any
}


export default /*#__PURE__*/_defineComponent({
  props: {
    prev: null,
    next: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (__props.prev)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: __props.prev.to,
          class: "lp-card lpager__link"
        }, {
          default: _withCtx(() => [
            _createVNode(HcIcon, {
              name: "chevron-left",
              size: 18
            }),
            _createElementVNode("span", null, [
              _createElementVNode("small", null, _toDisplayString(__props.prev.label), 1),
              _createElementVNode("strong", null, _toDisplayString(__props.prev.title), 1)
            ])
          ]),
          _: 1
        }, 8, ["to"]))
      : (_openBlock(), _createElementBlock("span", _hoisted_2)),
    (__props.next)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 2,
          to: __props.next.to,
          class: "lp-card lpager__link lpager__link--next"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createElementVNode("small", null, _toDisplayString(__props.next.label), 1),
              _createElementVNode("strong", null, _toDisplayString(__props.next.title), 1)
            ]),
            _createVNode(HcIcon, {
              name: "chevron-right",
              size: 18
            })
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true)
  ]))
}
}

})